import React from "react";

function CountBadge({ count = 0 }) {
	return (
		<>
			{count > 0 && (
				<span
					className="bg-linksColor absolute -right-[60%] -top-[10px] inline-flex items-center rounded-full
                                    bg-[#f44336] p-0.5 px-1.5 py-0.5 text-[12px] text-xs font-medium text-white ring-1 ring-inset ring-gray-500/10"
				>
					{count > 99 ? 99 : count}
				</span>
			)}
		</>
	);
}

export default React.memo(CountBadge);
